export const itemHeaderLightsOn = "$qc";
export default {itemHeaderLightsOn};